import {styled} from "@mui/material/styles"
import {breakpoints} from "@next/ux-fabric"

export const InnerContainer = styled("nav")`
    display: flex;
    height: 2.75rem;
    background-color: inherit;
    z-index: 2;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    align-items: center;
    max-width: ${breakpoints.values.xl}px;
    border-bottom: 0.0625rem solid ${({theme}) => theme.uxfabric.components.appBar.brandBar.default.borderColor};

    padding: 0 0.25rem 0 1rem;

    @media (min-width: ${breakpoints.values.md}px) {
        padding: 0 1.25rem 0 2rem;
    }

    @media (min-width: ${breakpoints.values.xl}px) {
        padding: 0 1.875rem 0 2.5rem;
    }
    .header-adaptive-search {
        margin: 0 0 0 auto;
    }
    .header-adaptive-checkout {
        flex-shrink: 0;
    }
    .countrylangselector {
        width: 2.75rem;
    }

    @media (min-width: ${breakpoints.values.md}px) {
        height: 3.75rem;
        .header-adaptive-search {
            margin: 0 auto 0 1.125rem;
        }
    }
`

export const HeaderContainer = styled("header")`
    box-shadow: ${({theme}) => theme.uxfabric.elevation.header};
`
